export const HORIZONTAL_SCROLL_EDGE_THRESHOLD = 2;
export const HORIZONTAL_SCROLL_FADE_WIDTH_PX = 30;
export const HORIZONTAL_SCROLL_FADE_COLOR = "#FFFFFF";
export const HORIZONTAL_SCROLL_FADE_TRANSPARENT_COLOR =
  "rgba(255, 255, 255, 0)";

const NO_OVERFLOW_STATE = {
  hasOverflow: false,
  atStart: true,
  atEnd: true
};

export const getHorizontalScrollStateFromMetrics = ({
  scrollLeft = 0,
  clientWidth = 0,
  contentWidth = 0
}) => {
  if (contentWidth <= clientWidth + HORIZONTAL_SCROLL_EDGE_THRESHOLD) {
    return NO_OVERFLOW_STATE;
  }

  const maxScrollLeft = contentWidth - clientWidth;

  return {
    hasOverflow: true,
    atStart: scrollLeft <= HORIZONTAL_SCROLL_EDGE_THRESHOLD,
    atEnd: scrollLeft >= maxScrollLeft - HORIZONTAL_SCROLL_EDGE_THRESHOLD
  };
};

export const getHorizontalScrollStateFromDom = (table, wrapper) => {
  if (!wrapper) {
    return NO_OVERFLOW_STATE;
  }

  const tableWidth = Math.max(
    table?.scrollWidth ?? 0,
    table?.offsetWidth ?? 0,
    table?.clientWidth ?? 0
  );

  return getHorizontalScrollStateFromMetrics({
    scrollLeft: wrapper.scrollLeft,
    clientWidth: wrapper.clientWidth,
    contentWidth: Math.max(wrapper.scrollWidth, tableWidth)
  });
};
